import { DocumentTemplatesCommonParams } from "@interfaces/company/document-templates";
import { documentTemplateService } from "@services/document-templates-service";
import { useMutation, useQueryClient } from "react-query";
import { documentTemplatesQueryKeys } from "./queryKeys";

export const useArchiveDocumentTemplateDirectoryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: DocumentTemplatesCommonParams) =>
      documentTemplateService.archiveDirectory(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(documentTemplatesQueryKeys.all);
      },
    }
  );
};
